import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Institution } from './Institution';

export interface LocationRow {
  id: number;
  institution_id: number;
  name: string;
  latitude: number | null;
  longitude: number | null;
  created_at: string;
  updated_at: string;
}

export const Location: Entity<LocationRow> = {
  id: 'Location',
  title: 'Location',
  service: 'main',
  rowLabel: (row: LocationRow) => row.name,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.location',
  },
  security: [
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: 'institution_id = {adminInstitutionId}',
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['name', 'ASC']],
  defaultFilters: [{ fieldId: 'name', operator: 'ct', value: '' }],
  listRowLink: '/admin/location/display/{key}',
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'ID',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
      autoIncrement: true,
    },
    institution_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Institution',
      refEntity: Institution,
      mandatory: true,
      listColumn: true,
      persistence: PersistenceType.SetOnCreateOnly,
    },
    name: {
      seq: 15,
      type: FieldType.Text,
      label: 'Location Name',
      mandatory: true,
      listColumn: true,
      maxLength: 255,
      description: 'Name or description of this location',
    },
    latitude: {
      seq: 20,
      type: FieldType.Decimal,
      label: 'Latitude',
      listColumn: true,
      editable: false,
      description: 'Geographic latitude (e.g., 51.5074 for London). Use "Set Coordinates" to update.',
      decimalDigits: 5,
    },
    longitude: {
      seq: 25,
      type: FieldType.Decimal,
      label: 'Longitude',
      listColumn: true,
      editable: false,
      description: 'Geographic longitude (e.g., -0.1278 for London). Use "Set Coordinates" to update.',
      decimalDigits: 5,
    },
    created_at: {
      seq: 30,
      type: FieldType.Datetime,
      label: 'Created At',
      persistence: PersistenceType.BackEndManaged,
    },
    updated_at: {
      seq: 35,
      type: FieldType.Datetime,
      label: 'Updated At',
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
